import { Reducer } from 'redux';
import { IApplicationState } from './';
import { IQuestionChange, ISurveyQuestionEditModel, IValidationErrorCollection } from '../models';
import * as QuestionChangesAPI from '../services/QuestionChangesAPI';
import {
	ISingleQuestionChangesGetRequested,
	ISingleQuestionChangesGetSuccessful,
	ISingleQuestionChangesGetFailed,
	IQuestionChangesGetRequested,
	IQuestionChangesGetSuccessful,
	IQuestionChangesGetFailed,
} from './Actions';
import { ActionTypes } from './ActionTypes';

export interface IQuestionChangeState {
	questionChange?: IQuestionChange;
	questionChanges?: IQuestionChange[];
	isQuestionChangesLoading: boolean;
	isSingleQuestionChangesLoading: boolean;
	validationErrors?: IValidationErrorCollection;
	surveyId?: number;
}

export const defaultState: IQuestionChangeState = {
	isQuestionChangesLoading: false,
	isSingleQuestionChangesLoading: false,
};

type KnownActions =
	| ISingleQuestionChangesGetRequested
	| ISingleQuestionChangesGetSuccessful
	| ISingleQuestionChangesGetFailed
	| IQuestionChangesGetRequested
	| IQuestionChangesGetSuccessful
	| IQuestionChangesGetFailed;

export const ActionCreators = {
	GetSurveySingleQuestionChanges:
		(surveyQuestionId: number, includeChanges?: boolean) => (dispatch: any, getState: () => IApplicationState) => {
			dispatch({ type: ActionTypes.SURVEY_SINGLE_QUESTION_CHANGES_GET_REQUESTED });

			return QuestionChangesAPI.getQuestionChanges(
				getState().survey.surveyEditModel.survey.surveyId,
				{
					surveyQuestionIds: [surveyQuestionId],
				},
				includeChanges,
			)
				.then((questionChanges: IQuestionChange[]) => {
					dispatch({ type: ActionTypes.SURVEY_SINGLE_QUESTION_CHANGES_GET_SUCCEEDED, payload: questionChanges[0] });
				})
				.catch((ex) => {
					dispatch({ type: ActionTypes.SURVEY_SINGLE_QUESTION_CHANGES_GET_FAILED });
				});
		},
	GetSurveyQuestionChanges: (surveyQuestionIds: number[]) => (dispatch: any, getState: () => IApplicationState) => {
		dispatch({ type: ActionTypes.SURVEY_QUESTION_CHANGES_GET_REQUESTED });

		return QuestionChangesAPI.getQuestionChanges(getState().survey.surveyEditModel.survey.surveyId, {
			surveyQuestionIds,
		})
			.then((questionChanges: IQuestionChange[]) => {
				dispatch({ type: ActionTypes.SURVEY_QUESTION_CHANGES_GET_SUCCEEDED, payload: questionChanges });
				dispatch({ type: ActionTypes.SURVEY_QUESTIONS_SYNC_WITH_QUESTIONLIBRARY, payload: questionChanges });
			})
			.catch((ex) => {
				dispatch({ type: ActionTypes.SURVEY_QUESTION_CHANGES_GET_FAILED });
			});
	},
	SyncSingleSurveyQuestionChanges: (surveyQuestion: ISurveyQuestionEditModel) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SURVEY_QUESTION_SYNC_WITH_QUESTIONLIBRARY, payload: surveyQuestion });
	},
};

export const reducer: Reducer<IQuestionChangeState, KnownActions> = (state: IQuestionChangeState = defaultState, action: KnownActions) => {
	switch (action.type) {
		case ActionTypes.SURVEY_SINGLE_QUESTION_CHANGES_GET_REQUESTED:
			return { ...state, isSingleQuestionChangesLoading: true };
		case ActionTypes.SURVEY_SINGLE_QUESTION_CHANGES_GET_SUCCEEDED: {
			return { ...state, questionChange: { ...action.payload }, isSingleQuestionChangesLoading: false };
		}
		case ActionTypes.SURVEY_SINGLE_QUESTION_CHANGES_GET_FAILED: {
			return { ...state, isSingleQuestionChangesLoading: false };
		}
		case ActionTypes.SURVEY_QUESTION_CHANGES_GET_REQUESTED:
			return { ...state, isQuestionChangesLoading: true };
		case ActionTypes.SURVEY_QUESTION_CHANGES_GET_SUCCEEDED: {
			return { ...state, questionChanges: action.payload, isQuestionChangesLoading: false };
		}
		case ActionTypes.SURVEY_QUESTION_CHANGES_GET_FAILED: {
			return { ...state, isQuestionChangesLoading: false };
		}
	}
	return state;
};
